<template>
    <div class="row h-100">
        <loader-gif v-if="isRequestPayment" />
        <div v-if="!subscription_details?.is_paid" class="col-md-12 grid-margin stretch-card">
            <form class="forms-sample" @submit.prevent="submitForm">
                <div class="row">
                    <div class="col-md-12">
                        <SingleSelect :TextLabel="i18n.t('tables.payment.status')" :trackby="`id`" :label="`name`"
                            :valueProp="`id`" v-model="requestPayment.status"
                            :placeholder="i18n.t('tables.payment.status')" :arrayOptions="payementStatusList"
                            refs="status" :v="v$.status" />
                    </div>
                    <div v-if="requestPayment.status == 'paid'" class="col-md-12">
                        <div class="form-group mr-b-0em">
                            <date-field v-model="requestPayment.paymentDate"
                                :label="i18n.t('tables.payment.paymentDate')" :v="v$.paymentDate" :disabled="false" />
                        </div>
                    </div>

                    <div class="col-md-6">
                        <SingleSelect :TextLabel="i18n.t('tables.payment.paymentMethod')" :trackby="`id`"
                            :label="`name`" :valueProp="`id`" v-model="requestPayment.paymentMethod"
                            :placeholder="i18n.t('tables.payment.paymentMethod')" :arrayOptions="payment_methodsList"
                            refs="paymentMethod" :v="v$.paymentMethod" />
                    </div>
                    <div v-if="requestPayment.paymentMethod === 'Chèque bancaire'" class="col-md-6">
                        <SingleSelect :TextLabel="i18n.t('tables.payment.bankName')" :trackby="`id`" :label="`name`"
                            :valueProp="`id`" v-model="requestPayment.bankName"
                            :placeholder="i18n.t('tables.payment.bankName')" :arrayOptions="bank_namesList"
                            refs="bankName" :v="v$.bankName" />
                    </div>

                    <div v-if="requestPayment.paymentMethod === 'Chèque bancaire'" class="col-md-6">
                        <div class="form-group mr-b-0em">
                            <inputText v-model="requestPayment.chequeName" :label="i18n.t('tables.payment.chequeName')"
                                :v="v$.chequeName" :disabled="false" />
                        </div>
                    </div>
                    <div v-if="requestPayment.paymentMethod === 'Chèque bancaire'" class="col-md-6">
                        <div class="form-group mr-b-0em">
                            <inputText v-model="requestPayment.chequeNum" :label="i18n.t('tables.payment.chequeNum')"
                                :v="v$.chequeNum" :disabled="false" />
                        </div>
                    </div>

                    <div v-if="requestPayment.paymentMethod === 'Chèque bancaire' || requestPayment.status == 'scheduled'"
                        class="col-md-6">
                        <div class="form-group mr-b-0em">
                            <date-field v-model="requestPayment.dueDate"
                                :label="requestPayment.status == 'scheduled' ? i18n.t('tables.payment.accessBlockDate') : i18n.t('tables.payment.dueDate')"
                                :v="v$.dueDate" :disabled="false" :fixedDays="1" :isFixedDays="false" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mr-b-0em">
                            <price-input v-model="requestPayment.amount_paid"
                                :label="i18n.t('tables.payment.amount_paid')" :v="v$.amount_paid" :disabled="false" />
                        </div>
                    </div>
                    <div class="col-md-12 mt-5">
                        <div class="row">

                            <div class="col-md-12 mb-5">
                                <div class=" ">

                                    <p class="form__label"><b>{{
                                        i18n.t('views.clients.new_subscriptions.payment.regulation.net_total')
                                            }}</b> : {{ totalRemainingAmount }}
                                        {{ i18n.t('symbole.currency.mad') }}</p>

                                    <p class="form__label" :class="{ 'bg-validator': v$.amount_paid.$error }">
                                        <b>{{
                                            i18n.t('views.clients.new_subscriptions.payment.regulation.total_paid')
                                            }} : </b>
                                        {{ requestPayment.amount_paid }}
                                    </p>
                                    <p class="form__label"><b>{{
                                        i18n.t('views.clients.new_subscriptions.payment.regulation.remaining_amount')

                                            }}</b> :{{ remainingAmount
                                            }}
                                        {{ i18n.t('symbole.currency.mad') }}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="row">
                    <div class="col-12 text-right">
                        <button type="submit" class="btn btn-primary mr-2">
                            {{ i18n.t('button.pay') }}
                        </button>
                        <button type="button" @click="emptyState()" class="btn btn-cancel">
                            {{ i18n.t('button.cancel') }}
                        </button>
                    </div>
                </div>
            </form>

        </div>
        <div v-else class="col-md-12 grid-margin stretch-card d-flex justify-content-center align-items-center">

            <div class="text-center">
                <div>
                    <img class="img-access-rapide w-50" src="@/assets/img/icons/done.svg" alt="Selected Image">
                </div>
                <b class="green"> {{ i18n.t('views.clients.unpaid.pay.paid') }}</b>
            </div>
        </div>
    </div>


</template>

<script lang="ts">

import { defineComponent, ref, computed, watchEffect, watch } from "vue";
/*Components*/
import inputText from "@/components/inputsValidation/ReusableInput.vue";
import SingleSelect from "@/components/inputsValidation/SingleSelect.vue";
/*plugins*/
import { useRoute } from "vue-router";


import { FormWizard, TabContent } from 'vue3-form-wizard'
import 'vue3-form-wizard/dist/style.css'

import { useVuelidate } from "@vuelidate/core";
import { required, helpers, requiredIf, minLength, email, numeric, maxLength, maxValue, minValue } from "@vuelidate/validators";
import Swal from "sweetalert2";
import i18n from "@/i18n/index"
import dayjs from 'dayjs';
/*composables & states */
import { usePayment } from "@/composables/payment/usePayment";
import { PaymentRequest } from "@/interfaces/payment";
import { bank_names, payment_methods, clubUUID, subscriptions, summary_subscriptions, payementStatus, currentClub, logoImage } from '@/shared/state';
import { useCreditPDF } from "@/composables/pdf/useCreditPDF";
import { useUnsavedChangesGuard } from '@/composables/global/useUnsavedChangesGuard'

import { useGlobal } from "@/composables/global/useGlobal";


const APP_URL = process.env.VUE_APP_URL;
export default defineComponent({
    components: {
        inputText, SingleSelect
    },
    props: {
        subscriptionDetails: {
            default: null,
            type: Object,
        }
    },
    name: "component-inscription",
    setup(props) {
        const subscription_details = computed(() => props?.subscriptionDetails);
        const bank_namesList = computed(() => bank_names.value);
        const payment_methodsList = computed(() => payment_methods.value);
        const payementStatusList = computed(() => payementStatus.value);
        const {
            getBase64Image,
            convertToBase64,
        } = useGlobal();

        const route = useRoute();
        let memberUUID = route?.params?.memberUUID?.toString() ?? null

        const action = ref('add')
        const is_paid = ref(false)
        const requestPayment = ref<PaymentRequest>({
            id: null,
            amount_paid: null,
            paymentMethod: null,
            bankName: null,
            chequeName: null,
            chequeNum: null,
            dueDate: null,
            paymentDate: dayjs(new Date()).format('YYYY-MM-DD'),
            status: "paid",
            pack_id: null, //subscription_details?.value?.pack_id,
            subscription_id: null, // subscription_details?.value?.subscription_id,
            member_subscription_id: null, // subscription_details?.value?.id,
            clubUUID: clubUUID.value,
            memberUUID: memberUUID,
            reference_id: subscription_details?.value?.id,
            reference_type: "subscriptions"
        });
        const { updateInitialState } = useUnsavedChangesGuard(() => requestPayment.value);
        const { regulationSubscription, isRequestPayment, errorPayment } = usePayment();
        const { exportPaymentReceipt } = useCreditPDF();
        // Validation   
        const rules = {
            id: {},
            paymentMethod: {
                required: helpers.withMessage(i18n.t("validation.required"), required)
            },
            bankName: {
                requiredIf: requiredIf(() => requestPayment.value.paymentMethod === 'Chèque bancaire')
            },
            chequeName: {
                requiredIf: requiredIf(() => requestPayment.value.paymentMethod === 'Chèque bancaire')
            },
            chequeNum: {
                requiredIf: requiredIf(() => requestPayment.value.paymentMethod === 'Chèque bancaire')
            },
            dueDate: {
                requiredIf: requiredIf(() => requestPayment.value.paymentMethod === 'Chèque bancaire' || requestPayment.value.status === 'scheduled')
            },
            paymentDate: {
                required: helpers.withMessage(i18n.t("validation.required"), required)
            },
            amount_paid: {
                required: helpers.withMessage(i18n.t("validation.required"), required),
                numeric,
                paidAmountValid: helpers.withMessage(
                    i18n.t("validation.amountExceededError"),
                    (value) => {
                        const numberValue = Number(value);
                        return numberValue !== null && numberValue <= totalRemainingAmount.value;
                    }
                )
            },
            // pack_id: {
            //     required: helpers.withMessage(i18n.t("validation.required"), required),
            // },
            // subscription_id: {
            //     required: helpers.withMessage(i18n.t("validation.required"), required),
            // },
            // member_subscription_id: {
            //     required: helpers.withMessage(i18n.t("validation.required"), required),
            // },
            clubUUID: {
                required: helpers.withMessage(i18n.t("validation.required"), required),
            },
            memberUUID: {
                required: helpers.withMessage(i18n.t("validation.required"), required),
            }



        };
        const v$ = useVuelidate(rules, requestPayment, { $scope: 'regulation' });



    

        /**
         * Add or edit member
         */
        const submitForm = async () => {
            // requestPayment.value.pack_id = subscription_details?.value?.pack_id
            // requestPayment.value.subscription_id = subscription_details?.value?.subscription_id
            requestPayment.value.reference_id = subscription_details?.value?.id ?? null
            requestPayment.value.clubUUID = clubUUID.value
            requestPayment.value.memberUUID = memberUUID
            v$.value.$touch();
            if (!v$.value.$invalid) {
                if (action.value === "add") {
                    Swal.fire({
                        title: i18n.t("message.confirmation.add.title"),
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: i18n.t("button.add"),
                        cancelButtonText: i18n.t("button.cancel"),
                        allowOutsideClick: false,   // ✅ disable closing by clicking outside
                        allowEscapeKey: false       // (optional) disable closing with ESC
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            await regulationSubscription(requestPayment.value).then((res) => {
                                if (res?.data) {
                                    is_paid.value = res?.data?.member_subscription?.is_paid ?? false
                                    subscription_details.value.total_amount = res?.data?.member_subscription?.total_amount
                                    subscription_details.value.total_amount_paid = res?.data?.member_subscription?.total_amount_paid
                                    subscription_details.value.remaining_amount = res?.data?.member_subscription?.remaining_amount
                                    subscription_details.value.discount_type = res?.data?.member_subscription?.discount_type
                                    subscription_details.value.discount_amount = res?.data?.member_subscription?.discount_amount
                                    subscription_details.value.discount_rate = res?.data?.member_subscription?.discount_rate
                                    subscription_details.value.total_fees = res?.data?.member_subscription?.total_fees
                                    subscription_details.value.is_paid = res?.data?.member_subscription?.is_paid
                                    subscription_details.value.transactions.push(res?.data?.transaction)

                                    summary_subscriptions.data.total_amount = subscription_details.value.total_amount
                                    summary_subscriptions.data.total_amount_paid = subscription_details.value.total_amount_paid
                                    summary_subscriptions.data.remaining_amount = subscription_details.value.remaining_amount



                                    Swal.fire({
                                        title: i18n.t('message.confirmation.export.invoice.success_paid'),
                                        text: i18n.t('message.confirmation.export.invoice.title'),
                                        icon: "success",

                                        showDenyButton: true,
                                        denyButtonText: i18n.t('message.confirmation.export.invoice.button.print'),
                                        denyButtonColor: "#3085d6",

                                        showCancelButton: true,
                                        cancelButtonColor: "#d33",
                                        cancelButtonText: i18n.t('button.cancel'),

                                        showConfirmButton: true,
                                        confirmButtonColor: "#3085d6",
                                        confirmButtonText: i18n.t('message.confirmation.export.invoice.button.pdf'),
                                        allowOutsideClick: false,   // ✅ disable closing by clicking outside
                                        allowEscapeKey: false       // (optional) disable closing with ESC

                                    }).then(async (result) => {
                                        emptyState()

                                        const logoImageData = logoImage.value ? getBase64Image(logoImage.value) : null;
                                        if (result.isConfirmed) {

                                            exportPaymentReceipt(
                                                {
                                                    logoImageData,
                                                    logoNaturalWidth: logoImage?.value?.naturalWidth,
                                                    logoNaturalHeight: logoImage?.value?.naturalHeight,
                                                },

                                                currentClub.value, subscription_details.value, res?.data?.transaction, 'pdf');
                                        }
                                        if (result.isDenied) {

                                            exportPaymentReceipt({
                                                logoImageData,
                                                logoNaturalWidth: logoImage?.value?.naturalWidth,
                                                logoNaturalHeight: logoImage?.value?.naturalHeight,
                                            },
                                                currentClub.value, subscription_details.value, res?.data?.transaction, 'print');
                                        }
                                        // 2. منين ينجح السيف، عيط ليها هنا!
                                        updateInitialState();
                                    });
                                }
                                //if (!errorPayment.value)

                            }).catch((e) => {

                                is_paid.value = false
                                // 2. منين ينجح السيف، عيط ليها هنا!
                                updateInitialState();
                            })

                        }
                    });

                }
            }
        }

        const emptyState = () => {
            action.value = 'add';

            requestPayment.value.id = null
            requestPayment.value.amount_paid = null
            requestPayment.value.paymentMethod = null
            requestPayment.value.bankName = null
            requestPayment.value.chequeName = null
            requestPayment.value.chequeNum = null
            requestPayment.value.dueDate = null
            requestPayment.value.paymentDate = dayjs(new Date()).format('YYYY-MM-DD')
            requestPayment.value.pack_id = subscription_details?.value?.pack_id
            requestPayment.value.subscription_id = subscription_details?.value?.subscription_id
            requestPayment.value.reference_id = subscription_details?.value?.id
            requestPayment.value.reference_type = "subscriptions"
            requestPayment.value.clubUUID = clubUUID.value
            requestPayment.value.memberUUID = memberUUID
            v$.value.$reset();

        };

        watch(() => requestPayment.value.paymentMethod, (newValue) => {
            if (newValue !== 'Chèque bancaire') {
                requestPayment.value.bankName = null
                requestPayment.value.chequeName = null
                requestPayment.value.chequeNum = null
                requestPayment.value.dueDate = null
            }
        });





        const totalRemainingAmount = computed(
            () => {
                const total_amount = subscription_details?.value?.remaining_amount ?? 0;
                return parseFloat((total_amount).toFixed(2));
            }
        )
        const remainingAmount = computed(() => {
            const total_remaining_amount = totalRemainingAmount.value ?? 0
            const amount_paid = requestPayment?.value?.amount_paid ?? 0
            return parseFloat((total_remaining_amount - amount_paid).toFixed(2));
        });


        // Watch for changes in route parameters
        watchEffect(() => {
            const watchMemberUUID = route?.params?.memberUUID?.toString() ?? null
            if (watchMemberUUID != memberUUID) {
                memberUUID = watchMemberUUID
                requestPayment.value.memberUUID = memberUUID
            }
            requestPayment.value.clubUUID = clubUUID.value

        });



        return {
            /**
             * States
             */
            bank_namesList,
            payment_methodsList,
            payementStatusList,

            requestPayment,
            submitForm,

            emptyState,
            action,
            v$,
            i18n,

            APP_URL,

            totalRemainingAmount,
            remainingAmount,
            subscription_details,
            is_paid,
            dayjs,
            isRequestPayment
        };
    },
});
</script>

<style>
.green {
    color: #049748;
    font-size: 15px;
}
</style>